import React, { useState, setState, useEffect } from "react";
import logo from "../imgs/logo3.png";
import logo_finale from "../imgs/logo_modellistica_hd.jpg";
import { Link, useLocation } from "react-router-dom";
import { verifyLogin } from "../pages/api";
import { RxDashboard, RxBell } from "react-icons/rx";
import { FaRegUser } from "react-icons/fa6";
import { FiShoppingCart, FiBell } from "react-icons/fi";
import { Badge } from "./badge";

import { NotificationButton } from "../pages/admin_notification";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const Header = () => {
  const [sideBarHidden, setSideBarHidden] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userLogged, setUserLogged] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [cartItemsCount, setCartItemsCount] = useState(0);

  const location = useLocation();

  const navigation = [
    { name: "Home", href: "/" },
    { name: "Abbonamenti", href: "/abbonamenti" },
    { name: "Arretrati", href: "/arretrati" },
    { name: "Supporto", href: "/supporto" },
    { name: "Altri contenuti", href: "#" },
    { name: "Carrello", href: "/carrello" },
    { name: "Profilo", href: "/profilo" },
    { name: "Dashboard", href: "/admin/dashboard" },
    { name: "Notifiche", href: "/admin/notifiche" },
    { name: "Chi siamo", href: "/chi-siamo" },
  ];

  const altriContenutiLinks = [
    { name: "Indici", href: "/indici" },
    { name: "Files", href: "/link2" },
    { name: "Video", href: "/video" },
  ];

  useEffect(() => {
    const checkUser = async () => {
      const loggedIn = await verifyLogin();
      if (loggedIn.user) {
        setUserLogged(loggedIn);
        if (loggedIn.user.ruolo === "admin") {
          setIsAdmin(true);
        }
      }
    };

    checkUser();
  }, []);

  const toggleSideBar = () => {
    setSideBarHidden(!sideBarHidden);
  };

  const closeSideBar = () => {
    setSideBarHidden(true);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        // Dimensione per cui vogliamo nascondere la barra laterale
        setSideBarHidden(true); // Nasconde la barra laterale quando lo schermo diventa grande
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleCartItemCount = () => {
      axios.defaults.withCredentials = true;
      axios.get(`${API_URL}/getCartItemsCount`).then((response) => {
        console.log(
          "Numero di articoli nel carrello:",
          response.data.itemCount
        );
        setCartItemsCount(response.data.itemCount);
      });
    };

    if (userLogged) {
      handleCartItemCount();
    }
  }, [userLogged]);

  const [isAltriContenutiExpanded, setIsAltriContenutiExpanded] =
    useState(false);

  const toggleAltriContenuti = () => {
    setIsAltriContenutiExpanded(!isAltriContenutiExpanded);
  };

  return (
    <header className="sticky inset-x-0 top-0 z-50">
      <nav
        className="flex items-center justify-between lg:px-8 p-2 bg-white border-b w-full"
        aria-label="Global"
      >
        <div className="flex items-center justify-center w-full">
          {/* Logo centrato */}
          <div className="flex justify-start lg:justify-start items-center flex-1 w-1/2 sm:w-3/4 ml-2 mr-5">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Modellistica</span>
              <img
                className="h-auto max-h-8 sm:max-h-12 md:max-h-16 lg:max-h-20" // Ridotto ulteriormente il logo su schermi piccoli
                src={logo_finale}
                alt="Modellistica International"
                style={{
                  maxWidth: "100%", // Adatta la larghezza automaticamente
                  width: "auto",
                  height: "auto",
                  maxHeight: "60px", // Limita l'altezza massima anche su schermi più grandi
                  //minHeight: "30px", // Definisce un'altezza minima ridotta su schermi piccoli
                }}
              />
            </Link>
          </div>

          {/* Icona BurgerButton per schermi piccoli */}
          {/* Pulsante del menu per schermi piccoli */}

          <div className="lg:hidden mr-5 flex justify-end items-center gap-4">
            <Link to="/carrello" className="text-2xl my-2">
              <FiShoppingCart />
            </Link>

            <Link to="/profilo" className="text-2xl my-2">
              <FaRegUser />
            </Link>
            {/* Mostra il pulsante per la dashboard admin se l'utente è admin */}
            {isAdmin && (
              <>
                <Link to="/admin/dashboard" className="text-2xl my-2">
                  <RxDashboard />
                </Link>

                <NotificationButton />
              </>
            )}

            <BurgerButton isOpen={!sideBarHidden} onClick={toggleSideBar} />
          </div>

          {/*Menù di navigazione con schermo largo */}
          <div className="hidden lg:flex lg:gap-x-8 flex-grow justify-center ">
            {navigation.map((item) => {
              if (item.name === "Altri contenuti") {
                return (
                  <div
                    key={item.name}
                    className="relative"
                    onMouseEnter={() => setIsDropdownOpen(true)}
                    onMouseLeave={() => setIsDropdownOpen(false)}
                  >
                    <Link
                      to={item.href}
                      className={`text-sm font-semibold leading-6 text-gray-700 hover:text-blue-500 ${
                        location.pathname === item.href
                          ? "underline underline-offset-4"
                          : ""
                      }`}
                    >
                      {item.name}
                    </Link>
                    {isDropdownOpen && (
                      <div className="absolute top-full left-0 bg-white border rounded shadow-lg w-40">
                        {altriContenutiLinks.map((link) => (
                          <Link
                            key={link.name}
                            to={link.href}
                            className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                          >
                            {link.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }
              if (
                item.name !== "Carrello" &&
                item.name !== "Profilo" &&
                item.name !== "Dashboard" &&
                item.name !== "Notifiche"
              ) {
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`text-sm font-semibold leading-6 text-gray-700 hover:text-blue-500 ${
                      location.pathname === item.href
                        ? "underline underline-offset-4"
                        : ""
                    }`}
                  >
                    {item.name}
                  </Link>
                );
              } else {
                return null;
              }
            })}
          </div>

          {/*Pulsanti profilo, carrello, dashboard e notifiche */}
          <div className="hidden lg:mr-5 lg:flex lg:flex-1 lg:justify-end">
            <Link
              to="/carrello"
              className="relative text-xl sm:text-3xl lg:text-2xl m-2 "
            >
              {userLogged ? <FiShoppingCart /> : <></>}
              <Badge count={cartItemsCount} />
            </Link>
            {userLogged ? (
              <>
                <Link
                  to="/profilo"
                  className="text-xl sm:text-3xl lg:text-2xl m-2"
                >
                  <FaRegUser />
                </Link>
                {/* Mostra il pulsante per la dashboard admin se l'utente è admin */}
                {isAdmin && (
                  <>
                    <Link
                      to="/admin/dashboard"
                      className="text-xl sm:text-3xl lg:text-2xl m-2"
                    >
                      <RxDashboard />
                    </Link>

                    <NotificationButton />
                  </>
                )}
              </>
            ) : (
              <Link to="/login" className="font-semibold m-2 text-gray-900">
                Log in
              </Link>
            )}
          </div>
        </div>
      </nav>
      <div
        className={`flex flex-col justify-center items-center transition-all duration-[1000ms] w-full ease-in-out bg-white ${
          sideBarHidden ? "max-h-0" : "max-h-[550px] border-b border-black"
        } relative overflow-hidden`}
      >
        <div className="lg:hidden w-full">
          {navigation.map((item) => {
            if (item.name === "Altri contenuti") {
              return (
                <div key={`${item.name}-container`}>
                  {/* Pulsante per espandere/comprimere */}
                  <button
                    onClick={toggleAltriContenuti}
                    className="block text-left ml-5 px-2 py-2 w-full text-base font-semibold leading-7 text-gray-700 hover:text-blue-500 hover:bg-gray-100 transition duration-200"
                  >
                    {item.name} {isAltriContenutiExpanded ? "▲" : "▼"}
                  </button>
                  {/* Contenuto espandibile */}
                  {isAltriContenutiExpanded &&
                    altriContenutiLinks.map((link) => (
                      <Link
                        key={link.name}
                        to={link.href}
                        className={`${
                          location.pathname === link.href
                            ? "underline underline-offset-4"
                            : ""
                        } block text-left ml-10 px-2 py-2 w-full text-base font-semibold leading-7 hover:text-blue-500 text-gray-700 hover:bg-gray-100 transition duration-200`}
                      >
                        {link.name}
                      </Link>
                    ))}
                </div>
              );
            } else if (
              !userLogged &&
              (item.name === "Dashboard" || item.name === "Notifiche")
            ) {
              return null;
            } else if (!userLogged && item.name === "Profilo") {
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={toggleSideBar}
                  className={`${
                    location.pathname === item.href
                      ? "underline underline-offset-4"
                      : ""
                  } block text-left ml-5 px-2 py-2 w-full text-base font-semibold leading-7 hover:text-blue-500 text-gray-700 hover:bg-gray-100 transition duration-200`}
                >
                  Log in
                </Link>
              );
            } else {
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={toggleSideBar}
                  className={`${
                    location.pathname === item.href
                      ? "underline underline-offset-4"
                      : ""
                  } block text-left ml-5 px-2 py-2 w-full text-base font-semibold leading-7 hover:text-blue-500 text-gray-700 hover:bg-gray-100 transition duration-200`}
                >
                  {item.name}
                </Link>
              );
            }
          })}
        </div>
      </div>
    </header>
  );
};

const BurgerButton = ({ isOpen, onClick }) => (
  <button className="lg:hidden flex items-center h-5 w-5 " onClick={onClick}>
    <div className="sr-only">{isOpen ? "Close menu" : "Open menu"}</div>
    <div
      aria-hidden="true"
      className={`absolute h-0.5 w-5 bg-current transition duration-300 ease-in-out ${
        isOpen ? "rotate-45" : "-translate-y-1.5"
      }`}
    />
    <div
      aria-hidden="true"
      className={`absolute h-0.5 w-5 bg-current transition duration-300 ease-in-out ${
        isOpen ? "opacity-0" : "opacity-100"
      }`}
    />
    <div
      aria-hidden="true"
      className={`absolute h-0.5 w-5 bg-current transition duration-300 ease-in-out ${
        isOpen ? "-rotate-45" : "translate-y-1.5"
      }`}
    />
  </button>
);

export default Header;
